$(document).ready(function() {
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {
      param = metafield;
    } else {
      param = document.URL.split("products/")[1].split("?")[0].toUpperCase();
    }
    
    $.getJSON('https://financialmodelingprep.com/api/v3/stock_news?tickers=' + param + '&limit=10&apikey=3ccf620ce9315de8a4996e601373f716', function(data) {
      if (data && data.length > 0) {
        $('.overview-news-and-profile').show();
        $('#news_list').append('<table></table>');
        
        $.each(data, function(i, elem) {
          var newsLink = '<a target="_blank" rel="noreferrer" href="' + elem.url + '">' + elem.title + '</a>';
          var description = '<div class="news_descr">' + elem.text.substr(0, 500) + '...<a style="font-weight: 400; font-size: 13px !important;" target="_blank" rel="noreferrer" href="' + elem.url + '">[read more]</a></div>';
          var site = elem.site;
          
          var d = new Date(elem.publishedDate);
          var options = { year: 'numeric', month: 'short', day: 'numeric' };
          var date = d.toLocaleDateString('en-US', options);
          
          $('#news_list table').append(
            '<tr><td><strong>' + date + ' - </strong><a target="_blank" rel="noreferrer" href="https://' + site + '">' + site + '</a></td></tr>' +
            '<tr><td>' + newsLink + description + '</td></tr>'
          );
        });
      } else {
        $('.overview-news-and-profile').hide();
      }
    });
  });